import { ValidationLevel } from 'ui';
import { ServerValidationErrors } from 'app/infrastructure/data/validation';
import { GenericSavedReport, SavedReportsValidation, SavedReportValidation } from '../types-store';
import { SavedReportEvaluationWire } from '../types';

const getWarnings = <SavedReport extends GenericSavedReport>(
  validationErrors: ServerValidationErrors
): SavedReportValidation<SavedReport> =>
  Object.keys(validationErrors ?? {})
    .reduce((result, key) => {
      const validationError = validationErrors[key];

      return {
        ...result,
        [key]: {
          level: ValidationLevel.warning,
          messages: validationError.map(error => ({
            level: ValidationLevel.warning,
            message: typeof error === 'object' ? error.message : error
          }))
        }
      };
    }, {} as SavedReportValidation<SavedReport>);

export const mapSavedReportsWarnings = <SavedReport extends GenericSavedReport>(
  evalutions: SavedReportEvaluationWire[]
): SavedReportsValidation<SavedReport> =>
  (evalutions ?? [])
    .reduce((warnings, evalution) => {

      const warning = getWarnings(evalution.validationErrors);

      return (Object.keys(warning ?? {}).length ?? 0) > 0
        ? {
          ...warnings,
          [evalution.code?.v]: warning
        }
        : warnings;
    }, {} as SavedReportsValidation<SavedReport>);
